export default "__VITE_PUBLIC_ASSET__b82bee73__"